module.exports = __webpack_public_path__ + "img/bluedownarrow.7ce27a1e.svg";